export default "__VITE_ASSET__uevJmq$T__"